<div class="list-container">
  <rask-list [data]="results" id="produktSokResultat" [getSelectedFromRoute]="true">
    <rask-list-column header="{{ 'PRODUKT_LIST_NAMN' | translate }}" field="namn" width="20%" [sortable]="true">
      <ng-template let-row="row">
        <a [routerLink]="['/produkt', row.id, 'basdata']">
          {{row.namn}}
        </a>
        <a [routerLink]="['/produkt', row.id, 'basdata']" target="_blank">
          <i class="far fa-sm fa-external-link p-r-half"></i>
        </a>
      </ng-template>
    </rask-list-column>
    <rask-list-column header="{{ 'PRODUKT_LIST_BETECKNING' | translate }}" field="beteckning" [sortable]="true" [nowrap]="true"></rask-list-column>
    <rask-list-column header="{{ 'PRODUKT_LIST_PRODUKTGRUPP' | translate }}" field="produktgrupp" [sortable]="true" [nowrap]="true"></rask-list-column>
    <rask-list-column header="{{ 'PRODUKT_LIST_HANDELSSORTIMENTSKATEGORI' | translate }}" field="handelssortimentskategori" [sortable]="true" [nowrap]="true"></rask-list-column>
    <rask-list-column header="{{ 'PRODUKT_LIST_HANDELSSORTIMENT' | translate }}" width="20%" [sortable]="true" [nowrap]="true" [tooltip]="true">
      <ng-template let-row="row">
        @for (hs of row.handelssortimentList; track hs; let i = $index) {
          <rask-span>
            <a [routerLink]="['/handelssortiment', hs.handelssortimentId]">
              {{hs.namn}}
            </a>
            <a  [routerLink]="['/handelssortiment', hs.handelssortimentId]" target="_blank">
              <i class="far fa-sm fa-external-link p-r-half">
                @if (row.handelssortimentList.length !== i+1) {
                  ,
                }
              </i>
            </a>
          </rask-span>
        }
      </ng-template>
    </rask-list-column>
    <rask-list-column header="{{ 'PRODUKT_LIST_TRADSLAG' | translate }}" field="tradslag" [sortable]="true" [nowrap]="true" [tooltip]="true"></rask-list-column>
    <rask-list-column header="{{ 'PRODUKT_LIST_SORTIMENTSKOD' | translate }}" field="sortiment" [sortable]="true" [nowrap]="true" [tooltip]="true"> </rask-list-column>
    <rask-list-column header="{{ 'PRODUKT_LIST_AKTIV' | translate }}" field="aktiv">
      <ng-template let-value>
        @if (value) {
          <i class="far fa-check"></i>
        }
      </ng-template>
    </rask-list-column>
  </rask-list>
</div>